export enum INFO_COLUMN_MODE {
  DEFAULT = "DEFAULT",
  GIFT_SELECTION = "GIFT_SELECTION",
  MASKS = "MASKS",
}
